import { RequestTransformFunction } from 'maplibre-gl';
import { environment } from 'src/environments/environment';

/**
 * Origin the basemap styles (assets/json/evlight.json and evdark.json) name for
 * their `sprite` and `glyphs`. Keep in step with those files.
 */
const STYLE_MAP_ASSETS_ORIGIN = 'https://mapassets.gpstuner.net';

/**
 * MapLibre request transformer that re-homes the basemap's sprite and glyph
 * requests onto `environment.MAP_ASSETS_URL`.
 *
 * The styles hardcode the mapassets host, and that host sends no CORS headers,
 * so a page served from any other origin cannot fetch from it directly. The
 * lan build (served from *.local-ip.sh) therefore sets MAP_ASSETS_URL to the
 * dev-server proxy prefix from proxy.conf.json, and this swaps the origin for
 * it before MapLibre issues the request. Wherever MAP_ASSETS_URL is the host
 * itself the transformer is a no-op, and requests to any other host (tiles,
 * the style JSON, the app's own assets) always pass through untouched.
 */
export const transformMapRequest: RequestTransformFunction = (url: string) => {
  const origin = STYLE_MAP_ASSETS_ORIGIN;
  if (environment.MAP_ASSETS_URL === origin || !url.startsWith(origin + '/')) {
    return undefined;
  }
  return { url: environment.MAP_ASSETS_URL + url.substring(origin.length) };
};
